import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('property-sales', storeModule.createStoreModule('property-sales'))
